import MasteryDistributionBar from './MasteryDistributionBar';

export default MasteryDistributionBar;
